{
  "version": "v4.2.5",
  "name": "DexAccount",
  "bytecode": "0505404b409940b240ca40e60103050800402cd3bd481528b417051600ce0116011602aa16047a0e314dc3170616064313202f4c1816047a0e314dc31603cc17071605160777467a4c0418a0020c304c04a0020d2ba10201000106004029d365b302f9b41701160149191341f47b160047cb17021602c54c06ce000d0d160201024a01ce00170316011603130264a000a001a00213036417051704160147b116041605c11801000101010ad358cbdacfa0020c2f4c03ce00024a0216000201030101000ad3511324a7b4b1a50d2f1341937b1600a10201030202000cd375472acbb4b1a50d2f1341937b16001601a101a100",
  "codeHash": "66c27c91033d54a2d3edc97dbc36b35022274ddd8a7b84b724631ac37586ed48",
  "fieldsSig": {
    "names": [
      "parents",
      "owner",
      "refferer",
      "counter"
    ],
    "types": [
      "[ByteVec;2]",
      "Address",
      "Address",
      "U256"
    ],
    "isMutable": [
      true,
      false,
      false,
      true
    ]
  },
  "eventsSig": [],
  "functions": [
    {
      "name": "deposit",
      "paramNames": [
        "payer",
        "tokenId",
        "amount",
        "path",
        "at"
      ],
      "paramTypes": [
        "Address",
        "ByteVec",
        "U256",
        "ByteVec",
        "U256"
      ],
      "paramIsMutable": [
        false,
        false,
        false,
        false,
        false
      ],
      "returnTypes": []
    },
    {
      "name": "createAccount",
      "paramNames": [
        "ref"
      ],
      "paramTypes": [
        "Address"
      ],
      "paramIsMutable": [
        false
      ],
      "returnTypes": []
    },
    {
      "name": "asRef",
      "paramNames": [
        "defaultRef"
      ],
      "paramTypes": [
        "Address"
      ],
      "paramIsMutable": [
        false
      ],
      "returnTypes": [
        "Address"
      ]
    },
    {
      "name": "updateCounter",
      "paramNames": [
        "newCounter"
      ],
      "paramTypes": [
        "U256"
      ],
      "paramIsMutable": [
        false
      ],
      "returnTypes": []
    },
    {
      "name": "setParents",
      "paramNames": [
        "newParents"
      ],
      "paramTypes": [
        "[ByteVec;2]"
      ],
      "paramIsMutable": [
        false
      ],
      "returnTypes": []
    }
  ],
  "constants": [],
  "enums": []
}